// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1-2V_","label":"SetPasswdForm_label__1iGwc"};